import styled from 'styled-components'

export const InfoBanner = styled.div`
  gap: 0.8rem;
  text-align: center;
  justify-content: center;
  padding: 3rem 1rem;
  background-color: ${({ theme }) => theme.colors.primaryLight};

  @media screen and (min-width: 768px) {
    padding: 2.2rem 0;
  }
`

export const MobileInfoBanner = styled(InfoBanner)`
  display: flex;

  @media screen and (min-width: 768px) {
    display: none;
  }
`

export const DesktopInfoBanner = styled(InfoBanner)`
  display: none;

  @media screen and (min-width: 768px) {
    display: flex;
  }
`
